import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff, Building2, Loader2 } from 'lucide-react';

const LoginPage = () => {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        const result = await login(email, password);
        if (!result.success) setError(result.error);
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex" data-testid="login-page">
            {/* Left Side - Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gradient-to-br from-white to-slate-100">
                <div className="w-full max-w-md space-y-8 animate-fade-in">
                    <div className="text-center">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 mb-6 shadow-lg shadow-blue-500/30">
                            <Building2 className="w-8 h-8 text-white" />
                        </div>
                        <h1 className="text-4xl font-heading font-bold text-slate-800 tracking-tight">
                            SIEMPRE
                        </h1>
                        <p className="mt-2 text-slate-500">Portal Empresarial</p>
                    </div>

                    <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                        <div className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-slate-600 mb-2">Correo Electrónico</label>
                                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all shadow-sm" placeholder="correo@empresa.com" required data-testid="email-input" />
                            </div>
                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-slate-600 mb-2">Contraseña</label>
                                <div className="relative">
                                    <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all shadow-sm pr-12" placeholder="••••••••" required data-testid="password-input" />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors">{showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
                                </div>
                            </div>
                        </div>

                        {error && <div className="p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm" data-testid="error-message">{error}</div>}

                        <button type="submit" disabled={loading} className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg shadow-blue-500/30 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed" data-testid="login-button">
                            {loading ? <><Loader2 className="w-5 h-5 animate-spin" />Iniciando sesión...</> : 'Iniciar Sesión'}
                        </button>
                    </form>

                    <p className="text-center text-sm text-slate-400 mt-8">© 2025 SIEMPRE - Portal Empresarial</p>
                </div>
            </div>

            {/* Right Side - Image */}
            <div className="hidden lg:block lg:w-1/2 bg-cover bg-center relative" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWFtJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzEwMDAwMDAwfDA&ixlib=rb-4.1.0&q=85')` }}>
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/60 to-blue-800/40" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center text-white px-12">
                        <h2 className="text-5xl font-bold mb-4 drop-shadow-lg">SIEMPRE</h2>
                        <p className="text-lg text-blue-100 drop-shadow">Tiendas de Conveniencia</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
